/* eslint quotes: ["error", "single", {"allowTemplateLiterals": true}] */
import qs from 'qs';

/**
 * Build Url For Google Maps API
 * @param {String} apiKey the google map api key
 * @param {Object} funeralHome all of the funeral home info
 * @param {Number} zoomLevel the map zoom level
 * @returns {String} Returns a formated URL for Google Static Maps API
 */
export function urlBuilder(apiKey, funeralHome = {}, zoomLevel = 12) {
  const {
    profileData: {address1},
    location: {
      city: {fullName: city},
      state: {code: state},
      latitude,
      longitude,
    },
  } = funeralHome;
  const location =
    latitude && longitude
      ? `${latitude},${longitude}`
      : `${address1},${city},${state}`;

  const mapRoot = `https://maps.googleapis.com/maps/api/staticmap`;
  const query = qs.stringify({
    zoom: zoomLevel,
    size: '924x180',
    scale: '2',
    markers: `color:red|${location}`,
    center: location,
    key: apiKey,
  });

  return `${mapRoot}?${query}`;
}



// WEBPACK FOOTER //
// ./src/appModules/utilities/googleMapsUrlHelper.js